import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IndexResponse, ShowResponse } from '@api/models/response.model';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';

export interface CustomerAppUserProfile {
  id: string;
  municipality_id: string;
  municipality_name: string | null;
  afas_id: string;
  zoho_contact_id: string | null;
  wmo_reference: string | null;
}

export interface CustomerAppUser {
  id: string;
  name: string;
  email: string;
  created_at: string;
  has_logged_in: boolean;
  last_login_at: string | null;
  blocked: boolean;
  blocked_at: string | null;
  profile: CustomerAppUserProfile | null;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerAppUserService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/customer-app-users`;

  getUsers(
    page: number = 1,
    q: string = ''
  ): Observable<IndexResponse<CustomerAppUser>> {
    let params = new HttpParams().set('page', page);
    if (q.trim()) {
      params = params.set('q', q.trim());
    }

    return this.http.get<IndexResponse<CustomerAppUser>>(this.apiUrl, { params });
  }

  updateUser(
    id: string,
    payload: { email: string; name?: string }
  ): Observable<CustomerAppUser> {
    return this.http
      .put<ShowResponse<CustomerAppUser>>(`${this.apiUrl}/${id}`, payload)
      .pipe(map((response) => response.data));
  }
}
